import { Modal } from 'antd';
import { styled } from 'styled-components';

export const SelectInputWrapper = styled.div`
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    padding-right: 12px;
  }
  .ant-select-arrow {
    right: 7px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0;
  }
`;

export const ModalWrapper = styled(Modal)`
  .ant-modal-header {
    padding: 20px 24px 0;
    border-bottom: none;
  }
`;
